export const BLOCKHASH_STREAM_COMMITMENT = 'confirmed';

export const BLOCKHASH_LOCAL_CACHE_TTL_MS = 1_000;

export const BLOCKHASH_RESOLVER_MODES = ['off', 'observe', 'prefer'] as const;
export type BlockhashResolverMode = (typeof BLOCKHASH_RESOLVER_MODES)[number];

export const DEFAULT_BLOCKHASH_RESOLVER_MODE: BlockhashResolverMode = parseBlockhashResolverMode(
  typeof process !== 'undefined' && process.env !== undefined
    ? (process.env.NEXT_PUBLIC_MORFI_BLOCKHASH_RESOLVER_MODE ??
        process.env.EXPO_PUBLIC_MORFI_BLOCKHASH_RESOLVER_MODE ??
        process.env.MORFI_BLOCKHASH_RESOLVER_MODE ??
        'off')
    : 'off',
  'off',
);

export function parseBlockhashResolverMode(
  raw: string | undefined,
  fallback?: BlockhashResolverMode,
): BlockhashResolverMode {
  const value = (raw ?? '').trim();
  for (const mode of BLOCKHASH_RESOLVER_MODES) {
    if (value === mode) return mode;
  }
  if (fallback !== undefined) return fallback;
  throw new Error('BLOCKHASH_RESOLVER_MODE must be one of: off, observe, prefer');
}
